import { render, staticRenderFns } from "./mindex.vue?vue&type=template&id=7f07fafe&scoped=true"
import script from "./mindex.vue?vue&type=script&lang=js"
export * from "./mindex.vue?vue&type=script&lang=js"
import style0 from "./mindex.vue?vue&type=style&index=0&id=7f07fafe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f07fafe",
  null
  
)

export default component.exports